import { useEffect, useCallback } from 'react';
import useAppDispatch from 'hooks/useAppDispatch';
import { getUserAction } from 'store/modules/auth/actions';
import { setCookieSessionToken } from 'utils/session';
import { Button } from '@mui/material';
import { SocialIcon } from 'react-social-icons';
import { AUTH_URL } from 'utils/constants';
import { useError } from '../../../context/ErrorContext';

interface LinkedinButtonProps {
  isCompany: boolean;
}

function LinkedinButton({ isCompany }: LinkedinButtonProps) {
  const dispatch = useAppDispatch();
  const { showError } = useError();

  const state = `gria-${Math.floor(Math.random() * 10 ** 20)},${isCompany}`;
  const clientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID;

  const params = `?response_type=code&client_id=${clientId}&redirect_uri=${AUTH_URL}/login-linkedin&state=${state}&scope=r_liteprofile%20r_emailaddress`;
  const URL = `https://www.linkedin.com/oauth/v2/authorization${params}`;

  const width = Math.max(window.outerWidth * 0.25, 350);
  const height = Math.max(window.outerHeight * 0.75, 650);

  const linkedInEventListener = useCallback((event: any) => {
    const { data } = event;
    if (data.token) {
      setCookieSessionToken(data.token);
      dispatch(getUserAction(data.token));
    } else if (data.error !== 'canceled') {
      console.error('Erro ao realizar login, tente novamente mais tarde.');
    }
  }, []);

  useEffect(() => {
    window.addEventListener('message', linkedInEventListener);
    return () => {
      window.removeEventListener('message', linkedInEventListener);
    };
  }, []);

  const linkedInLogin = () => {
    const linkedinWindow = window.open(
      URL,
      'LinkedIn',
      `menubar=no,location=no,resizable=no,scrollbars=no,
        status=no,width=${width},height=${height},
        top=${window.screen.height / 2 - height / 2},left=${
        window.screen.width / 2 - width / 2
      }`
    );

    let verifyStateWindow: any = null;

    function verifyWindow() {
      if (!linkedinWindow || linkedinWindow.closed) {
        clearInterval(verifyStateWindow);
      }
    }

    verifyStateWindow = setInterval(verifyWindow, 500);
  };

  return (
    <Button
      onClick={linkedInLogin}
      fullWidth
      variant="outlined"
      startIcon={
        <SocialIcon
          bgColor="#590A9D"
          fgColor="white"
          network="linkedin"
          style={{ width: 20, height: 20 }}
        />
      }
    >
      entrar com linkedin
    </Button>
  );
}

export default LinkedinButton;
